import { render } from "./index.vue?vue&type=template&id=1c4866ce"
import script from "./index.vue?vue&type=script&lang=js"
export * from "./index.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/design/components/templates/online-shop-support/index.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "1c4866ce"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('1c4866ce', __exports__)) {
    api.reload('1c4866ce', __exports__)
  }
  
  module.hot.accept("./index.vue?vue&type=template&id=1c4866ce", () => {
    api.rerender('1c4866ce', render)
  })

}


export default __exports__